import classNames from 'classnames/bind';
import styles from './FieldSet.module.scss';
import { RichText } from '../RichText/RichText';

let cx = classNames.bind(styles);

export function FieldSet({ className, children, legend, ...props }) {
	const classNameArray = className?.split(' ') || [];

	return (
		<fieldset className={cx(['ns_fieldset', 'fieldset', ...classNameArray])} {...props}>
			{legend && (
				<legend>
					<RichText html={legend}></RichText>
				</legend>
			)}
			{children}
		</fieldset>
	);
}
